import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "thankyou" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: "https://www.payo.com.au/wp-content/uploads/2021/06/Frame.png" }, null, -1)
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.body), 1),
      _createElementVNode("a", {
        class: "btn btn-success",
        href: _ctx.buttonUrl
      }, _toDisplayString(_ctx.buttonText), 9, _hoisted_4)
    ])
  ]))
}